/**
 * Derives the registrable parent domain so the consent cookie is shared across
 * subdomains (e.g. www.ankorstore.com and fr.ankorstore.com share .ankorstore.com).
 * Ankorstore domains are two-label (ankorstore.com, ankorlocal.com).
 */
export function getConsentCookieDomain(hostname: string): string {
  const labels = hostname.split('.');
  // Single-label hosts (localhost) and IP addresses get no parent-domain rewrite:
  // a leading-dot domain is only meaningful for real registrable domains.
  const isIpAddress = /^\d+$/.test(labels[labels.length - 1]);
  if (labels.length < 2 || isIpAddress) {
    return hostname;
  }
  return `.${labels.slice(-2).join('.')}`;
}
